// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"12":"make","621":"constructor"}[chunkId] + "." + {"12":"16b39da4","621":"7ad74533"}[chunkId] + ".js";
};